export const messagesPaginator = (state) => state.messagesPaginator;
export const messageEditor = (state) => state.messageEditor;
export const user = (state) => state.user;
